
<template>
  <div class="footer-content">
    <div class="footer-content__main-wrapper" :class="[schemaMain.settings.backgroundColor]">
      <div class="footer-content__main-container container">
        <footer-main :schema="schemaMain"></footer-main>
        <footer-contact-social v-if="!schemaContact.settings.hideContact" :schema="schemaContact" :schemaEmail="schemaEmail"></footer-contact-social>
      </div>
    </div>
    <footer-sub-footer :schema="schemaSubfooter"></footer-sub-footer>
    <footer-to-top text="Top" :dynamicallyHide="true" :threshold="300"></footer-to-top>
  </div>
</template>

<script>
import FooterMain from '@/scripts/components/footer/FooterMain.vue';
import FooterContactSocial from '@/scripts/components/footer/FooterContactSocial.vue';
import FooterSubFooter from '@/scripts/components/footer/FooterSubFooter.vue';
import FooterToTop from '@/scripts/components/navigation/FooterToTop.vue';

export default {
  name: 'FooterDefault',
  components: {
    FooterMain,
    FooterContactSocial,
    FooterSubFooter,
    FooterToTop,
  },
  props: {
    schemaEmail: Object,
    schemaMain: Object,
    schemaContact: Object,
    schemaSubfooter: Object,
    footerAlign: {
      type: String,
      default: 'left',
    },
  },
  methods: {},
  data() {
    return {};
  },
  mounted() {},
};
</script>

<style lang="scss">
.footer-content {
  &__main-wrapper {
    min-height: 530px;
    position: relative;

    @include mobile-only {
      min-height: 0;
      padding-bottom: 160px;
    }
  }
  &__main-container {
    max-width: 1272px;
    display: flex;
    justify-content: space-between;
    padding-top: 72px;

    @include mobile-tablet {
      flex-direction: column;
    }

    @include mobile-only {
      padding-top: 0;
    }
  }
}
</style>
